<unity-badge id="notificationsCountBadge" 
    *ngIf="badgeCount > 0" 
    type="notification" 
    size="mini" 
    class="notification badge-count">
    {{ badgeCount }}
</unity-badge>
<ng-content></ng-content>